import React from 'react';
import WarmingFill from '@/assets/images/icons/warming-fill.react.svg?react';
import styles from '@/presentation/components/exception-issue-list/index.module.scss';
import { useTranslation } from 'react-i18next';

export const HintRow = (props: {style?: React.CSSProperties}) => {
  const { t } = useTranslation();
  return <div style={props.style} className={styles.hintRow}>
    <div className={styles.hint}>
      <WarmingFill/>
      {t("当前搜索条件中包含使用时长字段，2023年5月17日之前的数据不支持使用时长字段的分析。")}
    </div>
  </div>;
};
